export const GetOfferSection = () => {
  return (
    <section id="get-offer" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Get Your Cash Offer Today
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Tell us about your mixed-use property and we'll provide a fair, no-obligation cash offer within 48 hours.
          </p>
        </div>

        <form 
          id="mixed-use-offer-form"
          data-readdy-form
          action="https://readdy.ai/api/form/d5u9avj0o41p73073cr0"
          method="POST"
          className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 md:p-12 shadow-lg"
        >
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <label htmlFor="firstName" className="block text-sm font-semibold mb-2 text-gray-900">
                First Name *
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="John"
              />
            </div>
            <div>
              <label htmlFor="lastName" className="block text-sm font-semibold mb-2 text-gray-900">
                Last Name *
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="Smith"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <label htmlFor="email" className="block text-sm font-semibold mb-2 text-gray-900">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="john@example.com"
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-sm font-semibold mb-2 text-gray-900">
                Phone Number *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="(555) 123-4567"
              />
            </div>
          </div>

          <div className="mb-6">
            <label htmlFor="propertyAddress" className="block text-sm font-semibold mb-2 text-gray-900">
              Property Address *
            </label>
            <input
              type="text"
              id="propertyAddress"
              name="propertyAddress"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
              placeholder="123 Main Street, City, State, ZIP"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <label htmlFor="residentialUnits" className="block text-sm font-semibold mb-2 text-gray-900">
                Residential Units *
              </label>
              <input
                type="number"
                id="residentialUnits"
                name="residentialUnits"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="12"
              />
            </div>
            <div>
              <label htmlFor="commercialSpaces" className="block text-sm font-semibold mb-2 text-gray-900">
                Commercial Spaces *
              </label>
              <input
                type="number"
                id="commercialSpaces"
                name="commercialSpaces"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
                placeholder="3"
              />
            </div>
          </div>

          <div className="mb-6">
            <label htmlFor="commercialType" className="block text-sm font-semibold mb-2 text-gray-900">
              Commercial Space Type *
            </label>
            <select
              id="commercialType"
              name="commercialType"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
            >
              <option value="">Select type...</option>
              <option value="retail">Retail</option>
              <option value="office">Office</option>
              <option value="restaurant">Restaurant/Food Service</option>
              <option value="mixed">Mixed Commercial Uses</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="mb-6">
            <label htmlFor="propertyCondition" className="block text-sm font-semibold mb-2 text-gray-900">
              Property Condition *
            </label>
            <select
              id="propertyCondition"
              name="propertyCondition"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
            >
              <option value="">Select condition...</option>
              <option value="excellent">Excellent - Recently renovated, fully leased</option>
              <option value="good">Good - Well-maintained, stable tenancy</option>
              <option value="fair">Fair - Some vacancy or deferred maintenance</option>
              <option value="poor">Poor - Significant vacancy or major repairs needed</option>
            </select>
          </div>

          <div className="mb-6">
            <label htmlFor="timeline" className="block text-sm font-semibold mb-2 text-gray-900">
              Desired Timeline *
            </label>
            <select
              id="timeline"
              name="timeline"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all text-sm"
            >
              <option value="">Select timeline...</option>
              <option value="asap">As soon as possible (30-45 days)</option>
              <option value="1-3months">1-3 months</option>
              <option value="3-6months">3-6 months</option>
              <option value="flexible">Flexible / Just exploring</option>
            </select>
          </div>

          <div className="mb-8">
            <label htmlFor="additionalInfo" className="block text-sm font-semibold mb-2 text-gray-900">
              Additional Information
            </label>
            <textarea
              id="additionalInfo"
              name="additionalInfo"
              rows={4}
              maxLength={500}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-teal-500 focus:ring-2 focus:ring-teal-200 outline-none transition-all resize-none text-sm"
              placeholder="Tell us about tenant mix, vacancy, needed improvements, or any other details... (500 characters max)"
            ></textarea>
            <p className="text-xs text-gray-500 mt-2">Maximum 500 characters</p>
          </div>

          <button
            type="submit"
            className="whitespace-nowrap w-full bg-teal-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Get My Cash Offer
          </button>

          <p className="text-sm text-gray-500 text-center mt-6">
            By submitting this form, you agree to be contacted about your property. We respect your privacy and will never share your information.
          </p>
        </form>
      </div>
    </section>
  );
};